'use client'

import GenericErrorDialog from '@/components/dialogs/generic-error-dialog'
import React, { createContext, useContext, useState, ReactNode } from 'react'

interface ModalErrorContextProps {
  isModalErrorOpen: boolean
  setModalErrorOpen: (isOpen: boolean) => void
  setCustomModalMessage: (message: string) => void
}

const ModalErrorContext = createContext<ModalErrorContextProps | undefined>(
  undefined,
)

export const ModalErrorProvider = ({ children }: { children: ReactNode }) => {
  const [isModalErrorOpen, setModalErrorOpen] = useState<boolean>(false)

  const [customModalMessage, setCustomModalMessage] = useState<
    string | undefined
  >(undefined)

  return (
    <ModalErrorContext.Provider
      value={{ isModalErrorOpen, setModalErrorOpen, setCustomModalMessage }}
    >
      {children}
      <GenericErrorDialog
        isOpen={isModalErrorOpen}
        setIsOpen={setModalErrorOpen}
        modalMessage={customModalMessage}
      />
    </ModalErrorContext.Provider>
  )
}

export const useModalError = () => {
  const context = useContext(ModalErrorContext)
  if (!context) {
    throw new Error(
      'useModalError deve ser usado dentro de um ModalErrorProvider',
    )
  }
  return context
}
